import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Carrier } from "../../models/Carrier";
import { getCarriers } from "../../repositories/CarrierRepository";
import { TableCarrier } from "./components/TableCarrier";

export const useCarriers = (
	partId?: number,
	onError?: (error: Error) => void,
) => {
	return useQuery<Carrier[], Error>({
		queryKey: ["carriers", partId],
		queryFn: ({ signal }) => getCarriers({ partId }, signal),
		onError: onError,
	});
};

export const CarrierPage = () => {
	const { partId } = useParams();

	return (
		<>
			<HelmetDexteel title="Carriers" />
			<TableCarrier partId={partId} />
		</>
	);
};
